import React, { Component } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
} from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import RefreshIcon from '@mui/icons-material/Refresh';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: '#f5f7fa',
            py: 6,
          }}
        >
          <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
            <Paper
              sx={{
                p: { xs: 4, md: 6 },
                borderRadius: 4,
                border: '1px solid rgba(0,0,0,0.08)',
              }}
            >
              <Box
                sx={{
                  width: 88,
                  height: 88,
                  borderRadius: '50%',
                  bgcolor: 'rgba(237, 108, 2, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                  mb: 3,
                }}
              >
                <ReportProblemIcon
                  sx={{ fontSize: 44, color: '#ed6c02' }}
                />
              </Box>

              <Typography
                variant="h4"
                fontWeight={700}
                sx={{ mb: 1.5, color: '#1a2027' }}
              >
                Something went wrong
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 4,
                  color: '#637381',
                  lineHeight: 1.7,
                  maxWidth: 380,
                  mx: 'auto',
                }}
              >
                An unexpected error occurred while rendering this page. Please
                try again or contact support if the problem persists.
              </Typography>

              <Button
                variant="contained"
                size="large"
                startIcon={<RefreshIcon />}
                onClick={this.handleReset}
                sx={{
                  borderRadius: 3,
                  py: 1.5,
                  px: 5,
                  fontWeight: 700,
                  fontSize: '1rem',
                  bgcolor: '#1976d2',
                  '&:hover': {
                    bgcolor: '#1565c0',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                  },
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                Try Again
              </Button>
            </Paper>
          </Container>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
